module.exports = __webpack_public_path__ + "img/warning-icon.0ffbc22c.svg";